import { cn } from "@utils/tw"
import { ReactNode } from "react"

export const Input = ({
  label,
  type = "text",
  icon,
  name,
  value,
  onChange,
  className,
  inputClassName,
  placeholder,
  required,
  disabled,
  error,
  errorMessage,
}: {
  label?: string
  type?: string
  icon?: ReactNode
  name: string
  value?: string
  onChange?: (value: string) => void
  className?: string
  inputClassName?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  error?: boolean
  errorMessage?: string
}) => {
  return (
    <div className={cn("flex flex-col gap-1 text-grey-2", className)}>
      {label && (
        <label className="type-body-s" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="relative">
        <input
          type={type}
          name={name}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          className={cn(
            "!text-[16px] md:!type-ui-label",
            !inputClassName
              ? "!w-full !border !border-current !bg-transparent !rounded-md !type-ui-label !h-buttonLg md:!h-7 !pl-4 !pr-2"
              : inputClassName,
            icon ? "!pr-7 md:!pr-6" : "",
          )}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
        />
        {icon && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2 w-[1.4em] h-[1.4em] pointer-events-none">
            {icon}
          </div>
        )}
      </div>
      {error && <span className="type-body-s">{errorMessage}</span>}
    </div>
  )
}
